module.exports = __webpack_public_path__ + "static/media/fleetback-icon.18f9f84c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fleetback-icon.svg
// module id = 1060
// module chunks = 0